import React, { useState } from 'react'
import { Modal, OverlayTrigger, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import { renderTooltipClose } from 'utlis/helpers/Tooltips/CommonTooltips'
import { defaultCustomerAddress } from 'utlis/Apis/Customers_API';
import { toast } from 'react-toastify';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { SET_ADDRESS_DEFAULT_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_SET_ADDRESS_DEFAULT } from 'utlis/AppMessages/AppMessages';
import { connect } from 'react-redux';
import { setGlobalLoading } from 'redux/actions/actionCommon'


function DefaultCustomerAddressModel(props) {
    const { show, closeModal, address_id, onSave } = props
    const [modalLoading, setModalLoading] = useState(false)
    // const [createButtonDisable, setCreateButtonDisable] = useState(false)
    const [defaultLoading, setDefaultLoading] = useState(false)

    const defaultAddress = () => {
        setDefaultLoading(true)
        defaultCustomerAddress(props.currentUser.userToken, address_id).then(res => {
            setDefaultLoading(false)
            onSuccess(res)
        }).catch(err => {
            onError(err)
        })
    }
    const onError = (err) => {
        console.log(`${ERROR_WHILE_SET_ADDRESS_DEFAULT} getEmailEvents `, err.message)
        toast.dismiss();
        toast.error(err.message || UNKNOWN_ERROR_OCCURED, {
            autoClose: 2500,
            onClose: () => {
                setModalLoading(false)
                // setGlobalLoading(false)
                // setCreateButtonDisable(false)
                setDefaultLoading(false)
            }
        })

    }
    const onSuccess = (res) => {
        setDefaultLoading(true)
        const customerAddress = res.data
        if (customerAddress.success) {
            setDefaultLoading(false)
            onSave()
            window.scrollTo(0, 0)
            toast.dismiss();
            toast.success(SET_ADDRESS_DEFAULT_SUCCESSFULLY, {
                autoClose: 2000,
                onClose: () => { }
            })
            closeModal(!show)
        }

        if (customerAddress.error) {
            console.log(ERROR_WHILE_SET_ADDRESS_DEFAULT, res)
            // setCreateButtonDisable(false)
            setDefaultLoading(false)
            toast.dismiss();
            toast.error(customerAddress.message || ERROR_WHILE_SET_ADDRESS_DEFAULT, {
                autoClose: 3000,
            })
        }
    }


    return (
        <Modal show={show} onHide={closeModal} centered size="md">
            <Modal.Body className="st-modal pad-20">
                <div className="app-modal-content modal-add-customer p-0 min-height-auto">
                    <div className="add-customer-form">
                        <div className="d-flex justify-content-between">
                            <div className="app-modal-title-wrapper mb-2 mb-lg-3 p-0">
                                <p className="app-modal-title text-capitalize st-fw-600 st-fs-24">Set As Default Address</p>
                            </div>
                            <OverlayTrigger
                                placement={"bottom"}
                                overlay={renderTooltipClose}
                            >
                                <button
                                    className="st-round-btn st-btn-transparent  st-btn-sm d-flex align-items-center justify-content-center"
                                    onClick={props.closeModal && props.closeModal}
                                >
                                    <FeatherIcon
                                        icon="x"
                                        size="24"
                                        className="icon border st-default-rounded-block" />
                                </button>
                            </OverlayTrigger>
                        </div>
                        <div className="app-card customer-address-modal" >
                            <div className="app-card-content border st-default-rounded-block pad-20">
                                <div className="st-form d-flex justify-content-center flex-wrap align-items-center mb-0">
                                    <p className="st-fs-20 st-fw-600 mb-3 text-center">
                                        Are you sure you want to set this default address?
                                    </p>
                                    <div className="d-flex">
                                        <button
                                            style={{ minWidth: 80 }}
                                            type="submit"
                                            className="st-btn st-btn-gray p-0 d-flex align-items-center justify-content-center me-1"
                                            onClick={closeModal}
                                        >
                                            <span>Cancel</span>
                                        </button>
                                        <button
                                            style={{ minWidth: 80 }}
                                            type="submit"
                                            className="st-btn st-btn-primary p-0 d-flex align-items-center justify-content-center"
                                            // disabled={createUserButtonDisable}
                                            onClick={defaultAddress}
                                        >
                                            {
                                                defaultLoading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : (
                                                    <span>Save</span>
                                                )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            modalLoading && (
                                <div className="app-modal-loading-overlay position-absolute h-100 w-100 d-flex align-items-center justify-content-center">
                                    <Spinner animation="border" />
                                </div>
                            )
                        }
                    </div>
                </div>
            </Modal.Body>
        </Modal>)
}

const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(DefaultCustomerAddressModel)